import React from 'react';
import { Tooltip2 } from '@blueprintjs/popover2';

import { useCountdown } from '@f/hooks';

type OnRemoveAttempt = (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;

interface TargetProps {
  onClick: OnRemoveAttempt;
}

interface RemovalTooltipProps {
  renderTarget: (props: TargetProps) => React.ReactNode;
  onRemove: () => void;
  tooltipProps?: Record<string, unknown>;
}

export default function RemovalTooltip(props: RemovalTooltipProps) {
  const { renderTarget, onRemove, ...tooltipProps } = props;

  const [removalCountdown, setRemovalCountdown] = useCountdown();

  const onRemoveAttempt: OnRemoveAttempt = event => {
    event.stopPropagation();

    if (removalCountdown !== 0) {
      onRemove();
      setRemovalCountdown(0);
      return;
    }

    setRemovalCountdown(5);
  };

  return (
    <Tooltip2
      content={`Click again to confirm removal... ${removalCountdown}s`}
      position="top"
      isOpen={removalCountdown !== 0}
      {...tooltipProps}
    >
      {renderTarget({ onClick: onRemoveAttempt })}
    </Tooltip2>
  );
}
